
export default {
  devStoreConfig: false,
  disableChecklistMode: false,
  api: {
    default: 'https://bitcoin-api-dev.herokuapp.com/v0',
  },
  showStrategy: true,
  features: {
    Ledger: true,
    BTC: true,
    BOT: true,
    Ebay: true,
    balanceSelling: true,
  },
};



// WEBPACK FOOTER //
// ./config/config.production.js